import { Tooltip } from "../ui/tooltip"

export const PRIORITY_CLASSIFICATION_LABEL = "Priority classification"
export const SCORE_GREEN = "green"
export const SCORE_YELLOW = "yellow"
export const SCORE_RED = "red"

function dotSource(fill: string): string {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><circle cx="6" cy="6" r="6" fill="${fill}"/></svg>`
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
}

const SCORE_DOT: Record<string, string> = {
  [SCORE_GREEN]: dotSource("#22c55e"),
  [SCORE_YELLOW]: dotSource("#facc15"),
  [SCORE_RED]: dotSource("#ef4444"),
}

interface StoplightBadgeProps {
  readonly score?: string | null
  readonly reason?: string | null
}

export function StoplightBadge({ score, reason }: StoplightBadgeProps) {
  if (!score || !SCORE_DOT[score]) {
    return null
  }
  return (
    <Tooltip content={reason || "No reason recorded"} side="bottom">
      <img
        src={SCORE_DOT[score]}
        alt={`Stoplight ${score}`}
        className="inline-block h-3 w-3 flex-shrink-0"
      />
    </Tooltip>
  )
}

interface StoplightSummaryProps {
  readonly score?: string | null
  readonly reason?: string | null
}

export function StoplightSummary({ score, reason }: StoplightSummaryProps) {
  if (!score || !SCORE_DOT[score]) {
    return null
  }
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <p className="text-sm font-medium text-slate-900">{PRIORITY_CLASSIFICATION_LABEL}</p>
      <p className="mt-2 text-sm text-slate-700">{reason || "No reason recorded"}</p>
    </div>
  )
}
